import { Services, Service, Label } from './styles'

Services.Service = Service
Services.Label = Label

export default Services
